export default __webpack_public_path__ + "static/addNotes-4540d79c4ec371d5cc3e099400a348b6.jpg";